<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <g v-if="weight === 'THIN'">
            <path
                d="M4 6.17647H20M9 3H15M15.5 21H8.5C7.39543 21 6.5 20.0519 6.5 18.8824L6.0434 7.27937C6.01973 6.67783 6.47392 6.17647 7.04253 6.17647H16.9575C17.5261 6.17647 17.9803 6.67783 17.9566 7.27937L17.5 18.8824C17.5 20.0519 16.6046 21 15.5 21Z"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
            />
        </g>

        <g v-else-if="weight === 'REGULAR'">
            <path
                d="M4 6.17647H20M9 3H15M15.5 21H8.5C7.39543 21 6.5 20.0519 6.5 18.8824L6.0434 7.27937C6.01973 6.67783 6.47392 6.17647 7.04253 6.17647H16.9575C17.5261 6.17647 17.9803 6.67783 17.9566 7.27937L17.5 18.8824C17.5 20.0519 16.6046 21 15.5 21Z"
                stroke="currentColor"
                stroke-width="1.3"
                stroke-linecap="round"
            />
        </g>

        <g v-else>
            <path
                d="M4 6.17647H20M9 3H15M15.5 21H8.5C7.39543 21 6.5 20.0519 6.5 18.8824L6.0434 7.27937C6.01973 6.67783 6.47392 6.17647 7.04253 6.17647H16.9575C17.5261 6.17647 17.9803 6.67783 17.9566 7.27937L17.5 18.8824C17.5 20.0519 16.6046 21 15.5 21Z"
                fill="currentColor"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'delete-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>
